import React from "react";
import label from "../labels/dashboard_en.json";
export default function Dashboard() {
  return (
    <div className="dashboardContentArea">
      {/* <h3> {label.Dashboard}</h3> */}

      <div className="row dashboardCards">
        
      </div>
    </div>
  );
}

